import React from "react";
import styled from "styled-components";
import TimeFormat from 'components/commons/TimeFormat';
import PropTypes from 'prop-types';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import CupoySrefView from 'components/commons/router/CupoySrefView';
import { Colors } from 'stylecomponents';

/**
|--------------------------------------------------
| Variables
|--------------------------------------------------
*/
const WEEK_TIME = 604800000; 
/**
|--------------------------------------------------
| Styled
|--------------------------------------------------
*/
const Container = styled.div`
  display: block;
  margin: 0 10px;
  cursor: pointer;
  &:not(:last-child) {
    border-bottom: 1px solid #E8E8E8;
  }
`;
const Item = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 15px 6px;
  border-top: solid #e8e8e8 1px;
  color: ${Colors.Dark3};
  font-size: 14px;

  &:nth-child(1) {
    border-top: none;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  min-width: 0;
  margin: 0 16px;
`;
const Text = styled.div`
  font-size: 14px;
  color: ${({ isTopBulletin }) => isTopBulletin ? '#F00' : 'inharit'};
`;
const NewIcon = styled.div`
  min-width: 34px;
  width: 34px;
  height: 16px;
  border-radius: 3px;
  background-color: #FB0007;
  margin-left: 6px;
  color: #FFF;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  font-weight: bold;
`;
const Tag = styled.div`
  min-width: 40px;
  width: 40px;
  font-size: 12px;
  font-weight: 700;
  background-color: ${({ BGColor }) => BGColor};
  color: #ffffff;
  padding: 1px 2px;
  border-radius: 2px;
  text-align: center;
`;

const Time = styled.div`
  font-size: 12px;
  color: #acacac;
  margin-left: auto;
  align-self: flex-end;
`;

function getTagColor(tag) {
  let color;

  switch (tag) {
    case '交易':
      color = Colors.MAIN_COLOR;//orange
      break;
    case '活動':
      color = Colors.Blue
      break;
    case '網站':
      color = '#00BCD4';
      break;
    case '新聞':
      color = '#00d400';
      break;
    default:
      color = Colors.DarkGreen;
      break;
  }

  return color;
}

const ActivityItem = props => {
  const {
    title = '',
    time,
    stateName,
    bulletinid,
    eventid,
    topbulletin,
  } = props;

  let _title = title;
  const tag = _title.slice(1, 3);
  _title = _title.slice(4);
  
  const routeState = stateName === CupoyRouter.STATES.NEWS ?
    CupoyRouter.STATES.NEWS_CONTENT
    :
    CupoyRouter.STATES.PROFITEVENT_CONTENT;

  const params =
    stateName === CupoyRouter.STATES.NEWS
      ?
      {
        id: bulletinid,
      }
      :
      {
        eventid,
        bulletinid,
      };
  
  const tagColor = getTagColor(tag);

  // 計算公告是否在七天內
  const midnightTime = new Date().setHours(0, 0, 0, 0);
  const compareTime = midnightTime - WEEK_TIME;
  const isShowNew = time > compareTime;
  const isTopBulletin = topbulletin === 1 || topbulletin === 3;

  return (
    <CupoySrefView
      statename={routeState}
      stylecomponent={Container}
      params={params}
    >
      <Item>
        <Tag BGColor={tagColor}>{tag}</Tag>
        <Content>
          <Text isTopBulletin={isTopBulletin}>{_title}</Text>
          {isShowNew && <NewIcon>NEW</NewIcon>}
        </Content>
        <Time>
          <TimeFormat
            time={time}
            format='timeString'
          />
        </Time>
      </Item>
    </CupoySrefView>
  );
};

ActivityItem.propTypes = {
  title: PropTypes.string.isRequired,
  time: PropTypes.number.isRequired,
  stateName: PropTypes.string.isRequired,
  addPadding: PropTypes.bool,
};

export default ActivityItem;
